// src/pages/NotFound.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

function Error() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://cdn.lordicon.com/lordicon.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <main className='site-width'>
        <div className="error-404">
            <div
            dangerouslySetInnerHTML={{
            __html: `
                <lord-icon
                src="https://cdn.lordicon.com/cvypfpcm.json"
                trigger="in"
                colors="primary:#121331,secondary:#244480"
                style="width:80px;height:80px;margin-bottom:20px">
                </lord-icon>
            `,
            }}
        />
        <h2>¡Oops! Error 404</h2>
        <p>Parece que la página que estás buscando no existe.</p>
        <Link to='/'>Volver al inicio</Link>
        </div>
    </main>
  );
}

export default Error;
